"use client";

import React from "react";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VisualImpactExcellence() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: false
  });
  return <section data-section-id="229983" id="course-hero" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-20 [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_40%,transparent_100%)] pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-7 flex flex-col gap-8">
            <div ref={textRef} className="flex flex-col gap-6">
              <h1 className="relative text-6xl sm:text-7xl md:text-8xl lg:text-[7rem] font-bold font-default tracking-tighter uppercase leading-[0.9]">
                {}
                <span className="block text-transparent" style={{
                WebkitTextStroke: "2px var(--color-primary)"
              }}>
                  ENGINEER
                  <br />
                  PRECISION
                </span>
                {}
                <span className="absolute inset-0 text-transparent bg-clip-text bg-no-repeat transition-all duration-[1500ms] ease-in-out" style={{
                backgroundImage: "linear-gradient(to right, var(--color-primary), var(--color-primary))",
                backgroundSize: isTextVisible ? "100% 100%" : "0% 100%",
                WebkitTextStroke: "2px var(--color-primary)"
              }} aria-hidden="true">
                  ENGINEER
                  <br />
                  PRECISION
                </span>
              </h1>

              <p className="font-default text-muted-foreground text-lg md:text-xl max-w-2xl leading-relaxed border-l-2 border-accent pl-6">
                Master advanced industrial design and structural engineering through our intensive professional certification programs. Gain hands-on expertise with cutting-edge simulation tools.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="rounded-none bg-gradient-to-r from-primary/90 via-primary to-primary/90 hover:from-primary hover:to-primary text-primary-foreground text-lg px-8 py-7 relative overflow-hidden group border border-primary/50 shadow-md">
                <Link to="/TrainingPage">
                  <span className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700 ease-in-out skew-x-12" />
                  <span className="relative z-10 flex items-center gap-2 font-semibold tracking-wide">
                    Enroll Now
                    <ArrowRight className="size-5 transition-transform group-hover:translate-x-1" />
                  </span>
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-none text-lg px-8 py-7 border-border/50 hover:bg-accent/10 hover:text-accent transition-colors">
                <Link to="/TrainingPage">
                  <span className="flex items-center gap-2 font-mono uppercase tracking-wider text-sm">
                    Course Syllabus
                    <ChevronRight className="size-4" />
                  </span>
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative h-[500px] lg:h-[700px] w-full">
            <div ref={imgRef} className="absolute inset-0 overflow-hidden border border-border/30 bg-muted/10 rounded-none" style={{
            transform: isImgVisible ? "translateY(0) scale(1)" : "translateY(40px) scale(0.95)",
            opacity: isImgVisible ? 1 : 0,
            transition: "all 1.2s cubic-bezier(0.16, 1, 0.3, 1)"
          }}>
              {}
              <div className="absolute inset-0 z-10 bg-gradient-to-tr from-background/40 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-6 left-6 z-20 backdrop-blur-md bg-background/80 border border-border/50 p-4 rounded-none">
                <p className="font-mono text-xs text-accent uppercase tracking-widest mb-1">
                  ● LIVE: ID-2024-ENG
                </p>
                <p className="font-default font-medium text-foreground">
                  Structural Simulation Analysis
                </p>
              </div>

              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/industrial_engineering_blueprint.png" alt="Advanced Industrial Engineering Blueprint" className="w-full h-full object-cover transition-transform duration-[2000ms] ease-out" style={{
              transform: isImgVisible ? "scale(1.05)" : "scale(1)"
            }} />
            </div>
            
            {}
            <div className="absolute -top-4 -right-4 size-24 border-t-2 border-r-2 border-accent/40 pointer-events-none" />
            <div className="absolute -bottom-4 -left-4 size-24 border-b-2 border-l-2 border-accent/40 pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}